'use strict'

import axios from 'axios'
import { axiosGet } from '../../../axios/axios.js'

export function getLegend (type) {
  const listLegend = []
  switch (type) {
    case 'table':
      listLegend.push({ id: 2, bg: 'white', color: 'black', name: 'Новый акт' }) // Выдано в работу
      listLegend.push({ id: 3, bg: 'blue-1', color: 'primary', name: 'Готов к проверке', colorBody: 'black' })
      listLegend.push({ id: 5, bg: 'yellow-4', color: 'black', name: 'Акт проверен' })
      listLegend.push({ id: 6, bg: 'grey-9', color: 'white', name: 'Доработка акта', bgJob: 'grey-3', colorJob: 'black' })
      listLegend.push({ id: 4, bg: 'red-2', color: 'negative', name: 'Работа принята', colorBody: 'black' })
      listLegend.push({ id: 1, bg: 'green-3', color: 'green-10', name: 'Работает', colorBody: 'black' })
      listLegend.push({ id: -100, class: 'legend-impossible-execute', name: 'Выполнить невозможно' })
      break
    case 'detector':
      listLegend.push({ id: 22, bg: 'white', color: 'black', name: 'Новый акт' }) // Выдано в работу
      listLegend.push({ id: 30, bg: 'blue-1', color: 'primary', name: 'Готов к проверке', colorBody: 'black' })
      listLegend.push({ id: 50, bg: 'deep-purple-11', color: 'white', name: 'Настройка Инвенто' })
      listLegend.push({ id: 36, bg: 'blue-grey-9', color: 'lime-3', name: 'Доработка объекта', bgJob: 'blue-grey-3', colorJob: 'black' })
      listLegend.push({ id: 29, bg: 'grey-9', color: 'white', name: 'Доработка акта', bgJob: 'grey-3', colorJob: 'black' })
      listLegend.push({ id: 23, bg: 'red-2', color: 'negative', name: 'Работа принята', colorBody: 'black' })
      listLegend.push({ id: 24, bg: 'yellow-4', color: 'lime-10', name: 'На аудите', add: 45, colorBody: 'black' }) // 24, 45
      listLegend.push({ id: 25, bg: 'green-3', color: 'green-10', name: 'Объект принят', colorBody: 'black' })
      listLegend.push({ id: 1000, class: 'legend-priority', name: 'Приоритеное задание' })
      listLegend.push({ id: 1001, class: 'legend-top-priority', color: '', name: 'Выполнить обязательно' })
      listLegend.push({ id: -100, class: 'legend-impossible-execute', name: 'Выполнить невозможно' })
      break
    case 'tl':
    case 't7':
      listLegend.push({ id: 287, bg: 'red-2', color: 'negative', name: 'Не готовы к утв.', colorBody: 'black' })
      listLegend.push({ id: 288, bg: 'yellow-4', color: 'black', name: 'Готовы к утв.' })
      listLegend.push({ id: 290, bg: 'grey-9', color: 'white', name: 'На доработке', bgJob: 'grey-3', colorJob: 'black' })
      listLegend.push({ id: 289, bg: 'green-3', color: 'green-10', name: 'Утверждены', colorBody: 'black' })

      listLegend.push({
        id: 2001,
        class: 'text-black bg-white',
        icon: 'mdi-flag-variant',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Регламент',
        actionName: 'Выполнен регламент',
        remainIndex: 7
      })
      listLegend.push({
        id: 2002,
        class: 'text-black bg-white',
        icon: 'mdi-format-color-text',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Адаптива',
        actionName: 'Выполнена настройка адаптивной системы',
        remainIndex: 8
      })
      listLegend.push({
        id: 2003,
        class: 'text-black bg-white',
        icon: 'mdi-phone',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Заявка',
        actionName: 'Выполнена заявка',
        remainIndex: 9
      })
      listLegend.push({
        id: 2004,
        class: 'text-black bg-white',
        icon: 'mdi-send',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Заявка из Диспетчерской',
        remainIndex: 4
      })
      listLegend.push({
        id: 2005,
        class: 'text-black bg-white',
        icon: 'mdi-flash',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Спецзадание',
        remainIndex: 1
      })
      listLegend.push({
        id: 2006,
        class: 'text-black bg-white',
        icon: 'mdi-checkbox-marked-outline',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Обследование СО',
        remainIndex: 3
      })
      listLegend.push({
        id: 2007,
        class: 'text-black bg-white',
        icon: 'mdi-invert-colors',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Покраска / Помывка',
        remainIndex: 5
      })
      listLegend.push({
        id: 2008,
        class: 'text-black bg-white',
        icon: 'mdi-wrench',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Строительство',
        remainIndex: 6
      })
      listLegend.push({
        id: 2009,
        class: 'text-black bg-white',
        icon: 'mdi-alert-outline',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Нанесение ущерба',
        remainIndex: 2
      })
      listLegend.push({
        id: 2010,
        class: 'text-black bg-white',
        icon: 'mdi-thumb-up-outline',
        colorSuccess: 'green-10',
        iconUnSuccess: 'mdi-thumb-down-outline',
        colorUnSuccess: 'negative',
        name: 'Аудит'
      })
      listLegend.push({
        id: 2011,
        class: 'text-black bg-white',
        icon: 'mdi-map-marker',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Контроль красного',
        remainIndex: 10
      })
      listLegend.push({
        id: 2012,
        class: 'text-black bg-white',
        icon: 'mdi-refresh',
        colorSuccess: 'green-10',
        colorUnSuccess: 'negative',
        name: 'Разворот',
        remainIndex: 11
      })
      listLegend.push({ id: 2013, class: 'text-black bg-white', icon: 'mdi-camera', colorSuccess: 'green-10', colorUnSuccess: 'negative', name: 'Фото' })

      break
    case 'kto':
      listLegend.push({ id: 2, bg: 'white', color: 'black', name: 'Новый акт' }) // Выдано в работу
      listLegend.push({ id: 3, bg: 'blue-1', color: 'primary', name: 'Готов к проверке', colorBody: 'black' })
      listLegend.push({ id: 74, bg: 'yellow-4', color: 'black', name: 'Акт проверен', colorBody: 'black' })
      listLegend.push({ id: 30, bg: 'blue-grey-9', color: 'white', name: 'Акт на доработке', bgJob: 'blue-grey-3', colorJob: 'black' })
      listLegend.push({ id: 4, bg: 'red-2', color: 'negative', name: 'Объект на доработке', colorBody: 'black' })
      listLegend.push({ id: 1, bg: 'green-3', color: 'green-10', name: 'Объект принят', colorBody: 'black' })
      listLegend.push({ id: 1000, class: 'legend-priority', name: 'Приоритеное задание' })
      listLegend.push({ id: 1001, class: 'legend-top-priority', color: '', name: 'Выполнить обязательно' })
      listLegend.push({ id: -100, class: 'legend-impossible-execute', name: 'Выполнить невозможно' })

      listLegend.push({ id: 2000, class: 'text-black bg-white', icon: 'mdi-fire', colorSuccess: 'red-14', name: 'АВР', type: 1 })
      listLegend.push({ id: 2001, class: 'text-black bg-white', icon: 'mdi-flag-variant', colorSuccess: 'blue-10', name: 'Регламент', type: 2 })
      listLegend.push({ id: 2002, class: 'text-black bg-white', icon: 'mdi-wrench', colorSuccess: 'green-10', name: 'Сервис', type: 3 })
      break
    case 'fvf':
      listLegend.push({ id: 36, bg: 'white', color: 'black', name: 'Новый акт' }) // Выдано в работу
      listLegend.push({ id: 37, bg: 'blue-1', color: 'primary', name: 'Готов к проверке', colorBody: 'black' })
      listLegend.push({ id: 76, bg: 'yellow-4', color: 'black', name: 'Акт проверен', colorBody: 'black' })
      listLegend.push({ id: 39, bg: 'blue-grey-9', color: 'white', name: 'Акт на доработке', bgJob: 'blue-grey-3', colorJob: 'black' })
      listLegend.push({ id: 38, bg: 'red-2', color: 'negative', name: 'Объект на доработке', colorBody: 'black' })
      listLegend.push({ id: 35, bg: 'green-3', color: 'green-10', name: 'Объект принят', colorBody: 'black' })
      listLegend.push({ id: 1000, class: 'legend-priority', name: 'Приоритеное задание' })
      listLegend.push({ id: 1001, class: 'legend-top-priority', color: '', name: 'Выполнить обязательно' })
      listLegend.push({ id: -100, class: 'legend-impossible-execute', name: 'Выполнить невозможно' })

      listLegend.push({ id: 2000, class: 'text-black bg-white', icon: 'mdi-flag-variant', colorSuccess: 'green-10', name: 'Общий', type: 66 })
      listLegend.push({ id: 2001, class: 'text-black bg-white', icon: 'mdi-spotlight', colorSuccess: 'green-10', name: 'Градуировка', type: 67 })
      listLegend.push({ id: 2002, class: 'text-black bg-white', icon: 'mdi-eye', colorSuccess: 'green-10', name: 'Поверка', type: 68 })
      listLegend.push({ id: 2003, class: 'text-black bg-white', icon: 'mdi-lead-pencil', colorSuccess: 'green-10', name: 'Отрисовка зон', type: 69 })
      listLegend.push({ id: 2004, class: 'text-black bg-white', icon: 'mdi-file-export', colorSuccess: 'green-10', name: 'Настройка выгрузки', type: 70 })
      break
    default:
      break
  }

  return listLegend
}

export function getLegendConfigTypes (legendConfig) {
  let legend = {}
  if (legendConfig && legendConfig.length) {
    legend = {
      job_regulations: legendConfig.find(itemLegend => itemLegend.id == 2001),
      job_adaptive: legendConfig.find(itemLegend => itemLegend.id == 2002),
      job_specification: legendConfig.find(itemLegend => itemLegend.id == 2003),
      control_room: legendConfig.find(itemLegend => itemLegend.id == 2004),
      special: legendConfig.find(itemLegend => itemLegend.id == 2005),
      survey: legendConfig.find(itemLegend => itemLegend.id == 2006),
      washout_painting: legendConfig.find(itemLegend => itemLegend.id == 2007),
      building: legendConfig.find(itemLegend => itemLegend.id == 2008),
      damage: legendConfig.find(itemLegend => itemLegend.id == 2009),
      audit_eye_open: { icon: 'mdi-eye', colorSuccess: 'blue', name: 'Идет аудит' },
      audit: legendConfig.find(itemLegend => itemLegend.id == 2010),
      control_red: legendConfig.find(itemLegend => itemLegend.id == 2011),
      turn: legendConfig.find(itemLegend => itemLegend.id == 2012),
      arrow_right: { icon: 'mdi-arrow-bottom-right', colorSuccess: 'green-10', colorUnSuccess: 'negative', name: 'Контурные стрелки', remainIndex: 12 }
    }
  }
  return legend
}

export function getToken () {
  return axios.post('/api-v1/api-user/login')
}

export function getEmployees () {
  return axiosGet({
    url: '/service/delta/employee/search?filter=none',
    onSuccess: (response) => {
      const result = JSON.parse(JSON.stringify(response.data.result))
      return result.map((item) => {
        return {
          id: item.id,
          name: item.name,
          key: item.key
        }
      })
    },
    onFailure: 'Ошибка загрузки сотрудников',
    msgTarget: this
  })
}

export function getServiceObjectType (type) {
  let name = ''
  switch (type) {
    case 'tl':
    case 'pto_tl':
      name = 'trafficLight'
      break
    case 't7':
    case 'pto_t7':
      name = 'trafficLightT7'
      break
    case 'kto':
    case 'pto_kto':
      name = 'cameraTV'
      break
    case 'detector':
    case 'pto_detector':
      name = 'transportDetector'
      break
    case 'table':
    case 'pto_table':
      name = 'TOI'
      break
    case 'fvf':
    case 'pto_fvf':
      name = 'cameraFVF'
      break
    default :
      break
  }
  return name
}

export function getServiceObjectByProperty (value, property = 'objectNumber', type = null) {
  // GET /service/delta/serviceobject/findServiceObjectByProperty?type=<необазательное>&property=<objectNumber по умолчанию>&value=<значение>
  let urlName = '/service/delta/serviceobject/findServiceObjectByProperty?value=' + value + '&property=' + property
  if (type) {
    urlName += '&type=' + type
  }
  return axiosGet({
    url: urlName,
    onSuccess: (response) => {
      return response.data
    },
    onFailure: 'Ошибка получения свойств объекта',
    msgTarget: this
  })
}
